export const toUpperCase = value => value && typeof value === 'string' ? value.toUpperCase() : null;